import {Injectable, NgZone} from '@angular/core';
import {SwUpdate} from '@angular/service-worker';
import {CoreService} from "../../common/core.service";
import {PubSubService} from "../../common/pub-sub.service";
import {ServerStartTimeService} from "../../common/core/server-start-time.service";

@Injectable({providedIn: 'root'})
export class NewVersionCheckerService {
    public versionIsOutOfDate: boolean = false;
    public latestEventText: string = "";

    constructor(
        private swUpdate: SwUpdate,
        private pubSubService: PubSubService,
        private core: CoreService,
        private zone: NgZone
    ) {
        pubSubService.subscribe(ServerStartTimeService.ServerWasRestartedSubject, () => {
            this.checkForNewVersion();
        });

        this.swUpdate.versionUpdates.subscribe(evt => {
            this.latestEventText = evt.type;
            switch (evt.type) {
                case 'VERSION_DETECTED':
                    console.log(`Downloading new app version: ${evt.version.hash}`);
                    this.versionIsOutOfDate = true;
                    break;
                case 'VERSION_READY':
                    console.log(`Current app version: ${evt.currentVersion.hash}`);
                    console.log(`New app version ready for use: ${evt.latestVersion.hash}`);
                    this.versionIsOutOfDate = true;
                    this.pubSubService.publish("NewVersion", true);

                    // automatic reload
                    // this.activateNewVersion(false).then()
                    //     .catch(error => {
                    //         console.error('Error activating new version:', error);
                    //     });
                    break;
                case 'VERSION_INSTALLATION_FAILED':
                    console.log(`Failed to install app version '${evt.version.hash}': ${evt.error}`);
                    break;
            }
        });

        navigator.serviceWorker.addEventListener('message', async (event) => {
            console.log("Service Worker message", event.data?.type, event);
            if (event.data && event.data.type === 'NEW_VERSION_AVAILABLE') {
                await this.activateNewVersion(false);
            }
        });

        setInterval(() => {
            let latestVersionCheckString = localStorage.getItem("latestVersionCheck");
            let latestVersionCheck = !!latestVersionCheckString ? new Date(latestVersionCheckString) : new Date();

            if (this.isOlderThanInMinutes(latestVersionCheck, this.pollingMinutes)) {
                this.checkForNewVersion();
            }
        }, this.pollingMinutes * 60 * 1000);
    }

    private pollingMinutes: number = 2;
    private deferredCheckForNewVersion: any;

    public checkForNewVersion() {
        // console.log("checkForNewVersion");

        if (!this.swUpdate.isEnabled) {
            console.log("checkForNewVersion can't run because swUpdate is disabled.");
            return;
        }

        if (this.deferredCheckForNewVersion) {
            clearTimeout(this.deferredCheckForNewVersion);
        }

        this.deferredCheckForNewVersion = setTimeout(async () => {
            // console.log("this.zone.runOutsideAngular");
            await this.zone.runOutsideAngular(async () => {
                try {
                    // console.log("await this.swUpdate.checkForUpdate.");
                    let isUpdated = await this.swUpdate.checkForUpdate();
                    // console.log(isUpdated ? 'A new version is available.' : 'Already on the latest version.');
                } catch (error) {
                    console.error('Failed to check for updates:', error);
                }
            });
        }, 500);
    }

    public async activateNewVersion(isManual: boolean) {
        console.log("activateNewVersion", isManual);

        if (isManual) {
            try {
                await this.zone.run(async () => {
                    console.log("activateNewVersion send");
                    navigator.serviceWorker?.controller?.postMessage({type: 'NEW_VERSION_AVAILABLE'});
                    console.log("activateNewVersion sent");
                });
            } catch (error) {
                console.error('Error while notifying update:', error);
            }
        } else {
            try {
                this.core.api.increaseBusyLevel(true, "Loading new version.");
                console.log("activateNewVersion activateUpdate");
                await this.swUpdate.activateUpdate();
                console.log("activateNewVersion reload");
                this.core.api.decreaseBusyLevel(true, "Loading new version.");
                document.location.reload();
            } catch (error) {
                console.error('Error while applying update:', error);
            }
        }
    }

    private isOlderThanInMinutes(dateToCheck: Date, minutes: number): boolean {
        const currentTime = new Date();
        const differenceInMilliseconds = currentTime.getTime() - dateToCheck.getTime();
        const differenceInMinutes = differenceInMilliseconds / (1000 * 60);
        return differenceInMinutes > minutes;
    }
}
